import React, { useRef, useEffect } from "react";
import { select, stack, scaleBand, scaleLinear, axisBottom, axisLeft, max } from "d3";
import { formatValue, tooltip } from "./Component";
import useResizeObserver from "Utils/resizeObserver"; 

const StackedBarChart = ({ wrapperRef, data, colors, label, keys, firstValue, secondValue }) => {
  const svgRef = useRef();
  const dimensions = useResizeObserver(wrapperRef);

  useEffect(() => {
    if (!data || !dimensions) return;

    const svg = select(svgRef.current);
    const marginTop = 20;
    const marginRight = 0;
    const marginBottom = 30;
    const marginLeft = 50;

    // Stack the data
    const stackedData = stack().keys(keys)(data);
    const yMax = max(stackedData, (layer) => max(layer, (d) => d[1])) + 5;

    // Scales
    const x = scaleBand()
      .domain(data.map((d) => d[label]))
      .range([marginLeft, dimensions.width - marginRight])
      .padding(0.2);

    const y = scaleLinear()
      .domain([0, yMax])
      .range([dimensions.height - marginBottom, marginTop])
      .nice();

    // Axes
    const xAxis = axisBottom(x).tickSizeOuter(0);
    const yAxis = axisLeft(y).tickFormat(formatValue);

    // Draw Axes
    svg.select(".x-axis")
      .attr("transform", `translate(0, ${dimensions.height - marginBottom})`)
      .call(xAxis);

    svg.select(".y-axis")
      .attr("transform", `translate(${marginLeft}, 0)`)
      .call(yAxis)
      .call((g) => g.select(".domain").remove());

      svg.selectAll(".layers")
      .data(stackedData)
      .join("g")
      .attr("class", "layers")
      .attr("fill", layers=>{
          return colors[layers.key]
      })
      .selectAll("rect")
      .data(layer=>layer)
      .join("rect")
      .attr("class", "bar")
      .attr("x", sequence=>{
          return x(sequence.data[label]) 
      })
      .attr("width", x.bandwidth())
      .attr("y", sequence=>y(sequence[1]))
      .on('mouseover', (event, d) => {
          // Show tooltip on hover
          tooltip.transition().style('opacity', 1);
          tooltip
          .html(`Date: ${d["data"][label]}<br/>${firstValue}: ${d["data"][firstValue]}
          <br/>${secondValue}: ${d["data"][secondValue]}`)
          .style('left', `${event.pageX}px`)
          .style('top', `${event.pageY - 28}px`);
      })
      .on('mouseout', () => {
          // Hide tooltip on mouseout
          tooltip.transition().duration(500).style('opacity', 0);
      })
      .transition()
      .attr("height", sequence=>y(sequence[0])-y(sequence[1]))

  }, [data, dimensions, colors, label, keys, firstValue, secondValue]);

  return (
    <div ref={wrapperRef} className="chart_wrapper_container">
      <svg ref={svgRef}>
        <g className="x-axis" />
        <g className="y-axis" />
      </svg>
    </div>
  );
};

export default StackedBarChart;
